/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Offline/view.blocks to change it.
import "DesignSystem/Fonts/Inter-300.css"
import LoadingBar from 'DesignSystem/LoadingBar/index'
import React from 'react'
import styles from './view.module.css'
import useIsMedia from 'Simple/hooks/useIsMedia'
import viewPath from './viewPath.js'
import { DialogOverlay as ViewsModalOverlay, DialogContent as ViewsModalOverlayContent } from '@reach/dialog'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Offline({
  children,
  viewPath = "/App/Form/Connection/Offline"
  
}) {
  let isMedia = useIsMedia()
  return (<React.Fragment
>
<ViewsModalOverlay
  data-testid="Offline.Vertical"
  data-view-path={viewPath}
 isOpen={true}
 className={`views-block ${styles.Vertical}`}
>
<ViewsModalOverlayContent
  data-testid="Offline.Vertical:1"
  data-view-path={viewPath}
 style={{'--w-1-8net1': isMedia.mobile ? "330px" : "400px"}}
 className={`views-block ${styles.Vertical1}`}
>
<span
  data-testid="Offline.Text"
  data-view-path={viewPath}
 className={`views-text ${styles.Text}`}
>
It appears you have gone offline. Retrying...
</span>
<LoadingBar
  viewPath={`${viewPath}/LoadingBar`}
 borderBottomLeftRadius={4}
 borderBottomRightRadius={4}
 borderTopLeftRadius={4}
 borderTopRightRadius={4}
 height={8}
 width="100%"
/>
</ViewsModalOverlayContent>
</ViewsModalOverlay>
{children}
</React.Fragment>)
}